import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-validate-form",
  templateUrl: "validate-form.html",
})
export class ValidateFormComponent {

  @Input() public form: FormControl;
  @Input() public message: string = "Invalid field";
  @Input() public submitAttempt: boolean;
}



// WEBPACK FOOTER //
// ./src/components/validate-form/validate-form.ts